import React, { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  FaHandPointDown,
  FaKey,
  FaSignInAlt,
  FaUser,
} from "react-icons/fa";
import { toast } from "react-toastify";
import axios from "axios";
import apiBaseUrl from "../../config/config";
import { useAuth } from "../AuthContext";
import "./Login.css";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, login } = useAuth();

  const SITE_CODE =
    apiBaseUrl.sitecodes || "P59";

  const [isSubmitting, setIsSubmitting] = useState(false);
  // const [formData, setFormData] = useState({
  //   user_name: "",
  //   password: "",
  //   site_code: apiBaseUrl.sitecodes,
  //   user_type: "User",
  // });

  const [formData, setFormData] = useState({
    user_name: "",
    password: "",
    site_code: SITE_CODE,
    user_type: "User",
  });

  // const destination = location.state?.from?.pathname || "/";
  const destination =
    location.state?.from?.pathname || "/";

  if (isAuthenticated) {
    return <Navigate to={destination} replace />;
  }

  const authenticate = async (credentials) => {
    if (isSubmitting) return;

    setIsSubmitting(true);

    try {
      console.log(
        "Login API URL:",
        `${apiBaseUrl.apiUrl}users/userAuthenticate`
      );

      console.log(
        "Login request:",
        credentials
      );

      const response = await axios.post(
        `${apiBaseUrl.apiUrl}users/userAuthenticate`,
        credentials,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("API URL:", response.config.url);
      console.log("Sent credentials:", credentials);
      console.log("HTTP status:", response.status);
      console.log("Login response:", response.data);

      const data = response.data;

      console.log(
        "Complete login response:",
        data
      );

      /*
       * API result number, string ya boolean mein
       * aa sakta hai.
       */
      const loginSuccessful =
        data.result === true ||
        data.result === 1 ||
        data.result === "1";

      if (!loginSuccessful) {
        toast.error(
          data.resultMessage ||
          data.message ||
          "Invalid credentials",
          {
            autoClose: 1000,
          }
        );

        return;
      }

      /*
       * Different possible API response structures
       * handle karega.
       */
      const returnedUser =
        data.resultData ||
        data.data ||
        data.user ||
        (typeof data.result === "object"
          ? data.result
          : null);

      if (!returnedUser) {
        console.error(
          "User data not recieved in API:",
          data
        );

        toast.error(
          "Login successful, but user data not found",
          {
            autoClose: 1200,
          }
        );

        return;
      }

      /*
       * Password ko Redux/localStorage mein
       * store nahi karna chahiye.
       */
      const {
        password: removedPassword,
        ...safeUserData
      } = returnedUser;

      /*
       * Kabhi-kabhi token resultData ke bajaye
       * top-level response mein milta hai.
       */
      // const finalUserData = {
      //   ...safeUserData,
      //   ...(data.login_token && {
      //     login_token: data.login_token,
      //   }),
      //   ...(data.token && {
      //     login_token: data.token,
      //   }),
      // };

      const loginToken =
        returnedUser?.login_token ||
        data?.login_token ||
        data?.token;

      if (!loginToken) {
        toast.error(
          "Login token API response mein nahi mila",
          {
            autoClose: 1500,
          }
        );

        return;
      }

      const finalUserData = {
        ...safeUserData,
        login_token: loginToken,
      };

      console.log(
        "User data sent to AuthContext:",
        finalUserData
      );

      const loginCompleted =
        login(finalUserData);

      if (!loginCompleted) {
        toast.error(
          "Login session create nahi ho saki",
          {
            autoClose: 1200,
          }
        );

        return;
      }

      // toast.success(
      //   data.resultMessage ||
      //   "Login successful",
      //   {
      //     autoClose: 500,
      //   }
      // );

      navigate(destination, {
        replace: true,
      });
    } catch (error) {
      console.error(
        "Login API error:",
        error.response?.data || error
      );

      toast.error(
        error.response?.data?.resultMessage ||
        error.response?.data?.message ||
        "An error occurred during login",
        {
          autoClose: 1200,
        }
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    authenticate({
      ...formData,
      user_name: formData.user_name.trim(),
      site_code: SITE_CODE,
    });
  };

  const loginWithDemoId = () => {
    authenticate({
      user_name: "demo",
      password: "Abcd1234",
      site_code: SITE_CODE,
      user_type: "User",
    });
  };

  return (
    <main className="login-page">
      <section className="login-main">
        <div className="brand" aria-label="BMW EXCH">
          <img className="form-logo" src="../Images/logo.png" alt="" />
        </div>

        <div className="login-card">
          <h1 className="login-title">
            Login <FaHandPointDown aria-hidden="true" />
          </h1>

          <form onSubmit={handleSubmit}>
            <label className="field-row">
              <span className="sr-only">Username</span>
              <input
                name="user_name"
                type="text"
                autoComplete="username"
                placeholder="Username"
                value={formData.user_name}
                onChange={(event) =>
                  setFormData((current) => ({
                    ...current,
                    user_name: event.target.value,
                  }))
                }
                required
              />
              <span className="field-icon">
                <FaUser size={16} aria-hidden="true" />
              </span>
            </label>

            <label className="field-row">
              <span className="sr-only">Password</span>
              <input
                name="password"
                type="password"
                autoComplete="current-password"
                placeholder="Password"
                value={formData.password}
                onChange={(event) =>
                  setFormData((current) => ({
                    ...current,
                    password: event.target.value,
                  }))
                }
                required
              />
              <span className="field-icon">
                <FaKey size={16} aria-hidden="true" />
              </span>
            </label>

            <button className="login-button" type="submit" disabled={isSubmitting}>
              <span>{isSubmitting ? "Please wait..." : "Login"}</span>
              <FaSignInAlt size={16} aria-hidden="true" />
            </button>

            <button
              className="login-button"
              type="button"
              onClick={loginWithDemoId}
              disabled={isSubmitting}
            >
              <span>Login with demo ID</span>
              <FaSignInAlt size={16} aria-hidden="true" />
            </button>
          </form>

          <p className="recaptcha-copy">
            This site is protected by reCAPTCHA and the Google
            <a href="https://policies.google.com/privacy">Privacy Policy</a> and
            <a href="https://policies.google.com/terms">Terms of Service</a> apply.
          </p>
        </div>
      </section>

      <footer className="login-footer">
        <nav aria-label="Legal">
          <a href="/terms">Terms and Conditions</a>
          <a href="/responsible-gaming">Responsible Gaming</a>
        </nav>
        <strong>24X7 Support</strong>
      </footer>
    </main>
  );
};

export default Login;
